// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w8cR5{display:inline-flex !important;margin-left:auto}.te8HT{margin-bottom:24px}.K2UQs{display:flex;align-items:center;gap:8px;flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpMeWriteButton": `w8cR5`,
	"mobile": `te8HT`,
	"toolbarActionsRow": `K2UQs`
};
export default ___CSS_LOADER_EXPORT___;
